module.exports = __webpack_public_path__ + "resource/img/exit-logo.00b5edf2.svg";